<template>
  <div>
    <div class="text-center text-4xl">{{ poll.question }}</div>
    <p class="text-center mt-3">{{ $t("poll.dragAndDrop") }}</p>

    <SortableList
      v-model="answers"
      class="mt-6 mx-auto w-full px-2"
      lock-axis="y"
      @input="onMove"
    >
      <SortableItem
        v-for="(answer, index) in answers"
        :key="answer.rank"
        :index="index"
        :rank="answer.rank"
        :value="answer.value"
      ></SortableItem>
    </SortableList>

    <button
      data-testid="vote"
      class="mt-4 w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      @click="vote"
    >
      {{ $t("global.vote") }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import shuffle from "shuffle-array";
import SortableList from "../components/SortableList";
import SortableItem from "../components/SortableItem";
import { createVote } from "../utils/request";

export default {
  name: "Poll",
  components: {
    SortableList,
    SortableItem
  },
  data() {
    return {
      answers: []
    };
  },
  computed: {
    ...mapGetters("user", ["userId"]),
    ...mapState({
      poll: state => state.poll.current,
      userId: state => state.user.id
    })
  },
  async mounted() {
    await this.setPoll(this.$route.params.id);

    if (!this.poll.users.includes(this.userId)) {
      this.$router.push({ name: "polls_list" });
    }

    this.answers = shuffle(this.poll.answers).map((answer, index) => {
      return {
        rank: index + 1,
        ...answer
      };
    });
  },
  methods: {
    ...mapActions("poll", ["setPoll", "fetchPoll"]),
    ...mapActions("app", ["addNotification"]),
    onMove(inputs) {
      this.answers = inputs.map((input, index) => {
        return {
          ...input,
          rank: index + 1
        };
      });
    },
    async vote() {
      const pollId = this.$route.params.id;
      const userId = this.userId;

      try {
        await createVote({ vote: this.answers }, pollId, userId);

        this.addNotification({
          text: "Merci de ton vote",
          status: "success"
        });

        this.$router.push({
          name: "polls_list"
        });
      } catch (error) {
        this.addNotification({
          text: "Il y a eu un problème",
          status: "error"
        });
      }
    }
  }
};
</script>

<style></style>
